/* eslint-disable prefer-const */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import './styles/modalPinCode.scss';
import {
    Grid,
    Row,
    cls,
    Keyboard,
    Form,
    Column,
    FormInput,
    Button,
    HeaderCompound,
} from '../../packages/components';
import { Tab } from '../../packages/components/lib/Keyboard/Tab';
import Translator from '../../requests/apa/Translator';
import {
    checkControlPin,
    remindControlPin,
    activateControlPin,
    activateControlPinWithoutEmail,
    getPinStatus,
    modifyControlPin,
    changeControlPin,
    controlPinCheck
} from '../../requests/loader';
import { MODAL_PIN_RECOVERY, MODAL_SUCCESS, MODAL_MATCH_DETAIL, showModal } from '../../actions/modal';
import Asset from 'src/requests/apa/Asset';
import getAppConfig from 'src/config/appConfig';
import AAF from 'src/AAF/AAF';
import { initTimerApiToUsePinStatus } from 'src/utils/pinParental/UtilsPin';
import Utils, {
    setInitialFocus,
    onFocusMultipleElements,
    isNumber,
    onFocusMultipleElementsRC,
    showSpinner
} from 'src/utils/Utils';
import PinParental from 'src/utils/PinParental';
import Device from 'src/devices/device';
import { setMetricsEvent } from '../../actions/metrics';
import store from 'src/store';
import {playFullMedia} from "../../actions/playmedia";
import { getPendingMatchModal, clearPendingMatchModal } from '../../containers/Mundial2026/FootballMatchDetail/pendingMatchModal';
import logger from 'src/utils/logger/logger';

const MAIN_CLASSNAME = 'aaf-modal-pin-code';
const MAX_CODE_LENGTH = 6;
const MIN_CODE_LENGTH = 4;
const INPUT_NAME_PREFIX = 'PIN_CODE';
const VCARD_COMPONENT = 'vcard';
const ACTION_PIN_DE_SEGURIDAD = 'pin de seguridad';
const LABEL_PIN_DE_SEGURIDAD_CANCELAR = 'cancelar';
const LABEL_PIN_DE_SEGURIDAD_SIGUIENTE = 'siguiente';
const LABEL_PIN_DE_SEGURIDAD_OLVIDASTE_PIN = 'olvidaste tu pin de seguridad ';

const KEYBOARD_CLASSNAME = 'aaf_keyboard';
const RC = 'RC';

export const MODAL_PIN_CODE_PURCHASE_TYPE = 'MODAL_PIN_CODE_PURCHASE_TYPE';
export const MODAL_PIN_CODE_CHANNEL_TYPE = 'MODAL_PIN_CODE_CHANNEL_TYPE';
export const MODAL_PIN_CODE_RATING_TYPE = 'MODAL_PIN_CODE_RATING_TYPE';
export const MODAL_PIN_CODE_LOCK_CHANNEL_TYPE_LIVE_TV = 'MODAL_PIN_CODE_LOCK_CHANNEL_TYPE_LIVE_TV';
export const MODAL_PIN_CODE_LOCK_CHANNEL_TYPE_SEARCHER = 'MODAL_PIN_CODE_LOCK_CHANNEL_TYPE_SEARCHER';
export const MODAL_PIN_CODE_CHANNEL_TYPE_SEARCHER = 'MODAL_PIN_CODE_CHANNEL_TYPE_SEARCHER';

export const PARENTAL_CHANNEL_TYPE = 'channels';
export const PARENTAL_CONTENT_TYPE = 'contents';
export const PARENTAL_PAYMENT_TYPE = 'payments';

//Modal status types
export const MP_ACTIVACION_PURCHASE = 'MP_ACTIVACION_PURCHASE';
export const MP_ACTIVACION_PARENTAL = 'MP_ACTIVACION_PARENTAL';
export const MP_CAMBIO_PIN = 'MP_CAMBIO_PIN';
export const MP_RECORDAR_PIN = 'MP_RECORDAR_PIN';
export const MP_CAMBIAR_STATUS = 'MP_CAMBIAR_STATUS';
export const MP_CHECAR_STATUS = 'MP_CHECAR_STATUS';
export const MP_STATUS_ACTIVAR = 'MP_STATUS_ACTIVAR';
export const MP_STATUS_DESACTIVAR = 'MP_STATUS_DESACTIVAR';

const PIN_RATING_DEFAULT = '20';

const generateInput = (length) => {
    const inputs = [];
    for (let i = 0; i < length; i++) {
        inputs.push({
            name: `code${i}`,
        });
    }
    return inputs;
};

const RequestPinCode = ({
    handleChange,
    showCode,
    togglePasswordVisibility,
    error = '',
    onFocus,
}) => {
    const inputs = generateInput(MAX_CODE_LENGTH);
    const showCodeAsset = showCode
        ? Asset.get('password_access_show_button_on')
        : Asset.get('password_access_show_button_off');
    return (
        <Row className={cls(`${MAIN_CLASSNAME}-row-inputs-show-button`)}>
            <Column lg={7}>
                <Row className={cls(`${MAIN_CLASSNAME}-row-inputs`)}>
                    {inputs.map((input, index) => {
                        const { name } = input;
                        const formInputProps = {};
                        formInputProps.errorFromBackend = error;
                
                        return (
                            <Column lg="1-5" className={cls(`${MAIN_CLASSNAME}-input`)}>
                                <FormInput
                                    key={`${INPUT_NAME_PREFIX}_${index}`}
                                    replaceWhenExceed
                                    id={`${INPUT_NAME_PREFIX}_${index}`}
                                    maxLength={1}
                                    onChange={(value) => {
                                        handleChange(index, value);
                                    }}
                                    focusWhenMount={index === 0}
                                    name={name}
                                    type={showCode ? 'password_shown' : 'password'}
                                    onFocus={onFocus}
                                    {...formInputProps}
                                />
                            </Column>
                        );
                    })}
                </Row>
            </Column>
            <Column lg={4} className={`${MAIN_CLASSNAME}-show-code-button-wrapper`}>
                <Button
                    id="btnShowPassword"
                    type="button"
                    variant="default"
                    className={cls(`focusable`, `${MAIN_CLASSNAME}-button-box-shadow`)}
                    onClick={togglePasswordVisibility}
                    onFocus={onFocus}
                    block
                >
                    <img
                        src={showCodeAsset}
                        alt="eye"
                        className={`${MAIN_CLASSNAME}-show-code-button`}
                    />
                    {/* <i className="fa fa-eye-slash" /> */}
                </Button>
            </Column>
        </Row>
    );
};
class ModalPinCode extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isNewCode: false,
            showCode: false,
            isEnabledButton: false,
            error: '',
            isEnableRecoveryPIN: false,
        };
        this.focusOnFirstEmptyInput = this.focusOnFirstEmptyInput.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.codeSelected = 'PIN_CODE_0';
        this.code = this.generateEmptyArray(MAX_CODE_LENGTH);
        const { action } = props;
        if (action === MP_CAMBIO_PIN) {
            this.newCode = this.generateEmptyArray(MAX_CODE_LENGTH);
        }
        this.emptyFunctionArr = [];
        this.keys = Device.getDevice().getKeys();
        this.onControlDeleteCallback = this.onControlDeleteCallback.bind(this);
        this.deleting = false;
        const PinManager = new PinParental();
        PinManager.hasPINParental().then((response) => {
            this.setState({
                isEnableRecoveryPIN: response,
            });
        });
    }

    generateEmptyArray = (lenght) => {
        const newArray = [];
        for (let i = 0; i < lenght; i++) {
            newArray.push('');
        }
        return newArray;
    };

    getEnteredCode = () => {
        return this.code.join('');
    };

    getEnteredNewCode = () => {
        return Array.isArray(this.newCode) && this.newCode.join('');
    };

    setValueInCodeByIndex = (index, value = '') => {
        if (index >= 0 && index < MAX_CODE_LENGTH) {
            const { isNewCode } = this.state;
            if (isNewCode) {
                this.newCode[index] = value;
            } else {
                this.code[index] = value;
            }
        }
    };

    performModifyControlPin = async (params = {}, type = '') => {

        let result = false,
            error = {};
        try {
            const res = await modifyControlPin(params);

            if (res && res.status === '0') {
                result = true;
            } else if (
                res &&
                res.errors &&
                typeof res.errors.error === 'function' &&
                res.errors.error[0]
            ) {
                error = res.errors.error[0];
            }
        } catch (err) {
            if (err && err.message) {
                error.message = err.message;
            }
            if (err && err.completeError && err.completeError.errors) {
                error = {
                    message: err.completeError.errors,
                };
            }
        }

        return {
            result,
            error,
        };
    };

    performChangeControlPin = async (params = {}) => {
        let result = false,
            error = {};
        try {
            const res = await changeControlPin(params);
            if (res && res.status === '0') {
                result = true;
            } else if (
                res &&
                res.errors &&
                typeof res.errors.error === 'function' &&
                res.errors.error[0]
            ) {
                error = res.errors.error[0];
            }
        } catch (err) {
            if (err && err.message) {
                error.message = err.message;
                this.enteredCodeFailed(err.message);
            }
        }
        return {
            result,
            error,
        };
    };

    performActivateControlPin = async (params = {}) => {
        let result = false,
            error = {};
        try {
            const res = await activateControlPin(params);
            if (res && res.status === '0') {
                result = true;
            } else if (
                res &&
                res.errors &&
                typeof res.errors.error === 'function' &&
                res.errors.error[0]
            ) {
                error = res.errors.error[0];
            }
        } catch (err) {
            if (err && err.completeError) {
                error.message = err.message;
            }
        }
        return {
            result,
            error,
        };
    };

    performActivateControlPinWithoutEmail = async (params = {}) => {
        let result = false,
            error = {};
        try {
            const res = await activateControlPinWithoutEmail(params);
            if ((res && res.status === '0')) {
                this.setBlokedChannels();
                result = true;
            } else if (
                res &&
                res.errors &&
                typeof res.errors.error === 'function' &&
                res.errors.error[0]
            ) {
                error = res.errors.error[0];
            }
        } catch (err) {
            if (err && err.completeError) {
                error.message = err.message;
            }
        }
        return {
            result,
            error,
        };
    };

    checkEnteredPin = async (params = {}) => {
        let result = false,
            error = {};
        try {
            // const res = await checkControlPin(params);
            const res = await controlPinCheck(params);
            const {data : {pincode_check = false} = {}} = res || {}
            this._lastCheckResponse = res;
            
            const isValid = res && res.data && res.data.is_valid;
            if (isValid) {
                result = true;
            } else if (res && res.data && !res.data.is_valid) { 
                error = { message: 'PIN inválido' };
            } else if (
                res &&
                res.errors &&
                typeof res.errors.error === 'function' &&
                res.errors.error[0]
            ) {
                error = res.errors.error[0];
            }
        } catch (err) {
            if (err && err.completeError) {
                error.message = err.completeError;
            }
        }
        return {
            result,
            error,
        };
    };

    recoveryPin = async () => {
        let result = false;
        try {
            const res = await remindControlPin();
            if (res && res.response) {
                result = true;
            }
        } catch (err) {
            result = false;
        }
        return result;
    };

    enableButtonWithCallback = (cb = () => {}) => {
        const { isEnabledButton } = this.state;
        if (!isEnabledButton) {
            this.setState({ isEnabledButton: true }, cb);
        } else {
            cb();
        }
    };

    disableButton = () => {
        const { isEnabledButton } = this.state;
        if (isEnabledButton) {
            this.setState({ isEnabledButton: false });
        }
    };

    focusOn = (selector) => window.SpatialNavigation.focus(selector);

    handleChange = (inputIndex, singleValue) => {
        //case when user press clear or empty tab or green or blue button
        if (singleValue === '') {
            const { error = '' } = this.state;
            if (error) {
                this.clearError();
            }
            this.setValueInCodeByIndex(inputIndex, singleValue);
            if (!this.code[inputIndex] && !this.deleting) {
                if (
                    (document && document.activeElement.className.includes(KEYBOARD_CLASSNAME)) ||
                    singleValue === ''
                ) {
                    this.focusOnPreviousInput(inputIndex);
                } else {
                    this.focusOnPreviousInput(inputIndex, RC);
                }
            }
        } else {
            this.setValueInCodeByIndex(inputIndex, singleValue);
            if (
                (document && document.activeElement.className.includes(KEYBOARD_CLASSNAME)) ||
                singleValue === ''
            ) {
                this.focusOnFirstEmptyInput();
            } else {
                this.focusOnFirstEmptyInput(RC);
            }
        }
        const hasCodeValidSize = this.hasCodeValidSize();
        if (hasCodeValidSize) {
            this.clearError();
            let focusOnConfirmButton = () => {};
            if (this.wasCodeEnteredCompletely()) {
                focusOnConfirmButton = () => this.focusOn(`#${MAIN_CLASSNAME}-confirm-button`);
            }
            this.enableButtonWithCallback(focusOnConfirmButton);
        } else {
            this.disableButton();
        }
    };

    wasCodeEnteredCompletely = () => {
        const { isNewCode } = this.state;
        if (isNewCode) {
            return this.getEnteredNewCode().length === MAX_CODE_LENGTH;
        } else {
            return this.getEnteredCode().length === MAX_CODE_LENGTH;
        }
    };

    hasCodeValidSize = () => {
        const { isNewCode } = this.state;
        let lengthPin;
        if (isNewCode) {
            lengthPin = this.getEnteredNewCode().length;
        } else {
            lengthPin = this.getEnteredCode().length;
        }
        return MIN_CODE_LENGTH <= lengthPin && lengthPin <= MAX_CODE_LENGTH;
    };

    focusOnPreviousInput(index, rc = null) {
        const previousInputIndex = index - 1;
        if (previousInputIndex >= 0 && previousInputIndex < MAX_CODE_LENGTH) {
            const el = document.getElementById(`${INPUT_NAME_PREFIX}_${previousInputIndex}`);
            if (el && typeof el.click === 'function') {
                this.codeSelected = el.id;
                this.onFocus();
                el.click();
                if (rc !== null)
                    onFocusMultipleElementsRC(this.getPinCodeActiveElemnt(), this.isFocusInput());
            }
        }
    }

    getPinCodeActiveElemnt() {
        return [
            { id: 'PIN_CODE_0', activeElement: this.codeSelected === 'PIN_CODE_0' },
            { id: 'PIN_CODE_1', activeElement: this.codeSelected === 'PIN_CODE_1' },
            { id: 'PIN_CODE_2', activeElement: this.codeSelected === 'PIN_CODE_2' },
            { id: 'PIN_CODE_3', activeElement: this.codeSelected === 'PIN_CODE_3' },
            { id: 'PIN_CODE_4', activeElement: this.codeSelected === 'PIN_CODE_4' },
            { id: 'PIN_CODE_5', activeElement: this.codeSelected === 'PIN_CODE_5' },
        ];
    }

    isFocusInput() {
        return document.activeElement.id.includes('PIN_CODE_') ? true : false;
    }

    focusOnFirstEmptyInput(rc = null) {
        let firstEmptyInputIndex;
        const { isNewCode } = this.state;
        if (isNewCode) {
            firstEmptyInputIndex = this.newCode.findIndex((el) => el === '');
        } else {
            firstEmptyInputIndex = this.code.findIndex((el) => el === '');
        }
        if (firstEmptyInputIndex >= 0 && firstEmptyInputIndex < MAX_CODE_LENGTH) {
            const el = document.getElementById(`${INPUT_NAME_PREFIX}_${firstEmptyInputIndex}`);
            if (el && typeof el.click === 'function') {
                this.codeSelected = el.id;
                this.onFocus();
                el.click();
                if (rc !== null || this.code.findIndex((el) => el === '') === 0)
                    onFocusMultipleElementsRC(this.getPinCodeActiveElemnt(), this.isFocusInput());
            }
        }
    }

    togglePasswordVisibility = () => {
        this.setState((prevState) => ({ showCode: !prevState.showCode }));
    };

    getRequestParams = async () => {
        const requestParams = {};
        const {
            type,
            action,
            activate,
            user: { user_id = '', session_userhash = '' } = {},
            pinRatings,
        } = this.props;
        if (action === MP_CAMBIO_PIN) {
            if (!this.state.isNewCode) {
                requestParams.userId = user_id;
                requestParams.controlPIN = encodeURIComponent(this.getEnteredCode());
            } else {
                requestParams.current_pin = encodeURIComponent(this.getEnteredCode());
                requestParams.new_pin = encodeURIComponent(this.getEnteredNewCode());
            }
        } else if (action === MP_CHECAR_STATUS) {
            requestParams.userId = user_id;
            requestParams.controlPIN = encodeURIComponent(this.getEnteredCode());
            return requestParams;
        } else if (action === MP_ACTIVACION_PARENTAL) {
            requestParams.pin_code = encodeURIComponent(this.getEnteredCode());
            requestParams.user_hash = session_userhash;
            switch (activate) {
                case PARENTAL_CHANNEL_TYPE:
                    requestParams.pin_channel = 1;
                    requestParams.pin_parental = 1;
                    requestParams.pin_ratings = pinRatings;
                    break;
                case PARENTAL_CONTENT_TYPE:
                    requestParams.pin_parental = 1;
                    requestParams.pin_ratings = pinRatings;
                    break;
                case PARENTAL_PAYMENT_TYPE:
                    requestParams.pin_purchase = 1;
                    break;
                default:
                    requestParams.pin_parental = 1;
                    requestParams.pin_ratings = pinRatings;
            }
        } else if (action === MP_CAMBIAR_STATUS) {
            requestParams.pin = encodeURIComponent(this.getEnteredCode());
            //requestParams.user_hash = session_userhash;
            if (type === MP_STATUS_DESACTIVAR) {
                requestParams.status_channel_pin = 0;
                requestParams.status_parental_pin = 0;
                requestParams.status_purchase_pin = 0;
                requestParams.accesss_parental_code = 0;
            } else {
                const res = await getPinStatus();
                switch (activate) {
                    case PARENTAL_CHANNEL_TYPE:
                        if (
                            res &&
                            res.response &&
                            res.response.pin_channel &&
                            res.response.pin_channel.status === 0
                        ) {
                            requestParams.status_channel_pin = 1;
                        } else {
                            requestParams.status_channel_pin = 0;
                        }
                        requestParams.status_parental_pin = res.response.pin_parental.status;
                        requestParams.status_purchase_pin = res.response.pin_purchase.status;
                        if (
                            res.response.pin_parental &&
                            res.response.pin_parental.info &&
                            res.response.pin_parental.info.value
                        ) {
                            requestParams.accesss_parental_code =
                                res.response.pin_parental.info.value;
                        }
                        break;
                    case PARENTAL_CONTENT_TYPE:
                        if (
                            res &&
                            res.response &&
                            res.response.pin_parental &&
                            res.response.pin_parental.status === 0
                        ) {
                            requestParams.status_parental_pin = 1;
                            requestParams.accesss_parental_code = pinRatings;
                        } else {
                            requestParams.status_parental_pin = 0;
                            if (
                                res.response.pin_parental &&
                                res.response.pin_parental.info &&
                                res.response.pin_parental.info.value
                            ) {
                                requestParams.accesss_parental_code =
                                    res.response.pin_parental.info.value;
                            }
                        }
                        requestParams.status_channel_pin = res.response.pin_channel.status;
                        requestParams.status_purchase_pin = res.response.pin_purchase.status;
                        break;
                    case PARENTAL_PAYMENT_TYPE:
                        if (
                            res &&
                            res.response &&
                            res.response.pin_purchase &&
                            res.response.pin_purchase.status === 0
                        ) {
                            requestParams.status_purchase_pin = 1;
                        } else {
                            requestParams.status_purchase_pin = 0;
                        }
                        requestParams.status_channel_pin = res.response.pin_channel.status;
                        requestParams.status_parental_pin = res.response.pin_parental.status;
                        if (
                            res.response.pin_parental &&
                            res.response.pin_parental.info &&
                            res.response.pin_parental.info.value
                        ) {
                            requestParams.accesss_parental_code =
                                res.response.pin_parental.info.value;
                        }
                        break;
                    default:
                }
            }
        }
        return requestParams;
    };

    isDeviceWithPinActivationWithoutEmail = () => {
        return (
            getAppConfig().device_category === 'stb' &&
            (getAppConfig().device_manufacturer === 'huawei' ||
                getAppConfig().device_manufacturer === 'kaonmedia' ||
                getAppConfig().device_manufacturer === 'activevideo' ||
                getAppConfig().device_manufacturer === 'ZTE')
        );
    };

    getRequestFunction = () => {
        const { action, type } = this.props;
        switch (action) {
            case MP_ACTIVACION_PARENTAL:
                if (this.isDeviceWithPinActivationWithoutEmail()) {
                    return this.performActivateControlPinWithoutEmail;
                } else {
                    return this.performActivateControlPin;
                }
            case MP_CAMBIO_PIN:
                return this.performChangeControlPin;
            case MP_CAMBIAR_STATUS:
                return this.performModifyControlPin;
            case MP_CHECAR_STATUS:
            default:
                return this.checkEnteredPin;
        }
    };

    setBlokedChannels = () => {
        getPinStatus()
            .then((resp) => {
                let blockedChannels = [];
                if (resp.status === '0' && resp.response) {
                    AAF.Pin.handleDataPinCodesSuccess(resp, blockedChannels);
                } else {
                    AAF.Pin.handleDataPinCodesError(blockedChannels);
                }
            })
            .catch((e) => {
                let blockedChannels = [];
                AAF.Pin.handleDataPinCodesError(blockedChannels);
            });
    };

    needsInitTimerApiToUsePinStatus = () => {
        const { action } = this.props;
        switch (action) {
            case MP_ACTIVACION_PARENTAL:
            case MP_CAMBIAR_STATUS:
                return true;
            default:
                return false;
        }
    };

    resetEnterCode = () => {
        if (
            Array.isArray(this.emptyFunctionArr) &&
            typeof this.emptyFunctionArr[0] === 'function'
        ) {
            this.emptyFunctionArr[0]();
        }
    };

    showCodeActivatedSuccessfully = () => {
        const modalProps = {
            modalProps: {
                defaultTitle: Translator.get('modal_pin_create_title', '¡Creaste tu PIN!'),
                content: Translator.get(
                    'modal_pin_create_msg',
                    'Ya puedes comenzar a gestionar tus Ajustes.'
                ),
                // callback: () => {
                // if (this.props.successCallBack) {

                //     this.props.successCallBack(currentPin);
                // }
                // },
            },
        };
        const modal = {
            modalType: MODAL_SUCCESS,
            ...modalProps,
        };
        const { showModal = () => {} } = this.props;
        showModal(modal);
    };

    handleSubmit = async () => {
        const { action, type } = this.props;
        const { isNewCode } = this.state;
        const errorMessage = Translator.get(
            'modal_activate_pin_message',
            'Por favor ingrese un pin de 4 a 6 dígitos'
        );
        Utils.sendMetric(
            this.props,
            ACTION_PIN_DE_SEGURIDAD,
            LABEL_PIN_DE_SEGURIDAD_SIGUIENTE,
            VCARD_COMPONENT
        );
        const requestParams = await this.getRequestParams();

        if (encodeURIComponent(this.getEnteredCode()) === '') {
            this.enteredCodeFailed(errorMessage);
            return;
        }

        if (action === MP_CAMBIO_PIN && !isNewCode) {
            const { result, error } = await this.checkEnteredPin(requestParams);
            if (result) {
                return this.setState({ isNewCode: true }, () => {
                    this.resetEnterCode();
                });
            } else {
                this.enteredCodeFailed(this.generateCodeFailed(error));
                return this.setState({ isNewCode: false }, () => {});
            }
        }
        const hasCodeValidSize = this.hasCodeValidSize();
        const requestFunction = this.getRequestFunction();
        if (hasCodeValidSize) {
            if (typeof requestFunction === 'function') {
                requestFunction(requestParams, type)
                    .then(({ result, error }) => {
                        if (this.needsInitTimerApiToUsePinStatus()) {
                            initTimerApiToUsePinStatus();
                        }
                        if (result) {
                            this.enteredCodeSucessfully();
                            if (
                                action === MP_ACTIVACION_PARENTAL &&
                                !this.isDeviceWithPinActivationWithoutEmail()
                            ) {
                                this.showCodeActivatedSuccessfully();
                            }
                            showSpinner(false);
                        } else {
                            this.enteredCodeFailed(this.generateCodeFailed(error));
                            showSpinner(false);
                        }
                    })
                    .catch((err) => {
                        logger.debug('ModalPinCode handleSubmit err', err);
                        this.enteredCodeFailed(err);
                        showSpinner(false);
                    });
            }
        }
        showSpinner(true);
    };

    generateCodeFailed(error) {
        let errorText = '';
        if(error && error.message && error.message[0] && error.message[0].code ) {
            //Nueva estructura de error de APis versionadas
            errorText = Translator.get(
                error.message[0].code.trim(),
                error.message[0].detail
            );
        } else if (error) {
             errorText = Translator.get("PinDeSeguridad_ErrorIngresaPin_Form_TextoTooltip1");
        }
        else if (error && error.message && error.message.code ) {
            errorText = Translator.get(
                error.message.code.trim(),
                error.message.errors
            );
        } else if (error && error.message) {
            error.message = err.message;
        } else if (typeof error === "string") {
            errorText = error;
        }

        return errorText;
    }

    focusOnLastElement = () => {
        const { lastFocus = null } = this.props;
        if (lastFocus) {
            setTimeout(() => {
                if (Utils.isModalHide()) {
                    this.onFocus();
                }
            }, 500);
        }
    };

    enteredCodeSucessfully = () => {
        const { successCallBack = () => {}, pinIsCreated = false } = this.props;
        const enteredCode = this.getEnteredCode();
        const checkResponse = this._lastCheckResponse || null;
        this.closeModal();
        successCallBack(enteredCode, pinIsCreated, checkResponse);
        this.focusOnLastElement();
    };

    enteredCodeFailed = (message) => {
        const { failedCallBack = () => {} } = this.props;
        if (message) {
            this.displayError(message);
        }
        failedCallBack();
    };

    handleCancel = () => {
        Utils.sendMetric(
            this.props,
            ACTION_PIN_DE_SEGURIDAD,
            LABEL_PIN_DE_SEGURIDAD_CANCELAR,
            VCARD_COMPONENT
        );
        if (!this.restorePendingMatchDetailModal()) {
            this.closeModal();
            const nullPlayer = {
            ispip: false,
            islive: true,
            playerstate: 'STOPPING',
            event: null,
            };
            store.dispatch(playFullMedia(nullPlayer));
            const { cancelCallBack = () => {} } = this.props;
            cancelCallBack();
        }
    };

    displayError = (content) => {
        this.setState({ error: content });
    };

    clearError = () => {
        this.setState({ error: '' });
    };

    handleYellowBack = () => {
        if (!this.restorePendingMatchDetailModal()) {
            this.closeModal();
            const nullPlayer = {
                ispip: false,
                islive: true,
                playerstate: 'STOPPING',
                event: null,
            };
            store.dispatch(playFullMedia(nullPlayer));
            const { cancelCallBack = () => {} } = this.props;
            cancelCallBack();
        }
    };

    restorePendingMatchDetailModal = () => {
        if (!this.props.playFromMatchDetail) {
            return false;
        }
        const pending = getPendingMatchModal();
        if (!pending) {
            return false;
        }
        clearPendingMatchModal();
        setTimeout(() => {
            showSpinner(true);
            store.dispatch(showModal({ modalType: MODAL_MATCH_DETAIL, modalProps: pending }));
        }, 100);
        return true;
    };

    closeModal = () => {
        const { handleClose = () => {} } = this.props;
        handleClose();
    };

    handleRecovery = () => {
        Utils.sendMetric(
            this.props,
            ACTION_PIN_DE_SEGURIDAD,
            LABEL_PIN_DE_SEGURIDAD_OLVIDASTE_PIN,
            VCARD_COMPONENT
        );
        const {
            showModal = () => {},
            user: { email = '' },
            cancelCallBack = () => {},
        } = this.props;
        cancelCallBack && typeof cancelCallBack === 'function' && cancelCallBack();
        this.recoveryPin()
            .then((result) => {
                if (result) {
                    showModal({
                        modalType: MODAL_PIN_RECOVERY,
                        modalProps: {
                            email,
                        },
                    });
                }
            })
            .catch((err) => {
                logger.debug('handleRecovery err', err);
            });
    };

    getText = () => {
        const { isNewCode } = this.state;
        const { type, action } = this.props;
        const text = {};
        if (isNewCode) {
            text.title = Translator.get('modal_pin_default_title', 'PIN de seguridad');
            text.subtitle = Translator.get(
                'modal_new_pin_messages',
                'Para continuar con el cambio, ingresa un nuevo PIN de seguridad.'
            );
        } else if (action === MP_CAMBIO_PIN) {
            text.title = Translator.get('modal_pin_default_title', 'PIN de Seguridad');
            text.subtitle = Translator.get(
                'modal_now_pin_subtitle',
                'Para continuar con el cambio, ingresa tu PIN de seguridad actual.'
            );
        } else if (action === MP_ACTIVACION_PARENTAL) {
            text.title = Translator.get('setupPin_modal_title_label', 'PIN de Seguridad');
            text.subtitle = Translator.get(
                'setupPin_modal_instruction_label',
                'Por favor ingrese un pin de 4 a 6 dígitos'
            );
        } else if (action === MP_CHECAR_STATUS && !type) {
            if (this.props.sectionTV) {
                text.title = Translator.get('modal_pin_default_title', 'PIN de Seguridad');
                text.subtitle = Translator.get(
                    'modal_pin_change_channels_subtitle',
                    'Ingresa tu PIN de seguridad para modificar tu lista de canales de TV bloqueados.'
                );
            } else {
                text.title = Translator.get('modal_pin_default_title', 'PIN de Seguridad');
                text.subtitle = Translator.get(
                    'modal_pin_classification_subtitle',
                    'Ingresa tu PIN de seguridad para modificar tu lista de clasificaciones de contenido bloqueado.'
                );
            }
        } else if (action === MP_CAMBIAR_STATUS) {
            if (type === MP_STATUS_DESACTIVAR) {
                text.title = Translator.get(
                    'modal_deactivate_pin_confrim_title',
                    'Desactivar Control Parental'
                );
                text.subtitle = Translator.get(
                    'modal_deactivate_pin_confrim_message',
                    'Al desactivar el Control Parental se perderán todos los ajustes previos, incluyendo la Protección de compras y los Canales bloqueados. ¿Estás seguro que deseas desactivar el Control Parental?'
                );
            } else {
                const statusLabelSubtitle = this.props.status_parental_pin
                    ? 'modal_pin_deactivate_button_subtitle'
                    : 'modal_pin_activate_button_subtitle';
                const status = this.props.status_parental_pin ? 'desactivar' : 'activar';

                text.title = Translator.get('modal_pin_default_title', 'PIN de Seguridad');
                text.subtitle = Translator.get(
                    statusLabelSubtitle,
                    `Ingresa tu PIN de seguridad para ${status} la sección de bloqueo seleccionada.`
                );
            }
        } else {
            switch (type) {
                case MODAL_PIN_CODE_PURCHASE_TYPE:
                    text.title = Translator.get('modal_pin_purchase_title', 'Compra bloqueada');
                    text.subtitle = Translator.get(
                        'modal_pin_purchase_subtitle',
                        'Ingresa tu PIN de seguridad para realizar esta compra.'
                    );
                    break;
                case MODAL_PIN_CODE_RATING_TYPE:
                    text.title = Translator.get('modal_pin_rating_title', 'Contenido bloqueado');
                    text.subtitle = Translator.get(
                        'modal_pin_rating_subtitle',
                        'Ingresa tu PIN de seguridad para ver este contenido.'
                    );
                    break;
                case MODAL_PIN_CODE_CHANNEL_TYPE_SEARCHER:
                case MODAL_PIN_CODE_CHANNEL_TYPE:
                    text.title = Translator.get('modal_pin_channel_title', 'Canal bloqueado');
                    text.subtitle = Translator.get(
                        'lockChannel_access_subtitleWatch_label',
                        'Ingresa tu PIN de seguridad de 4 a 6 caracteres  para ver este.'
                    );
                    break;
                case MODAL_PIN_CODE_LOCK_CHANNEL_TYPE_LIVE_TV:
                    text.title = Translator.get(
                        'lockChannel_access_title_label',
                        'Canal Bloqueado'
                    );
                    text.subtitle = Translator.get(
                        'lockChannel_access_subtitle_label',
                        'Ingresá tu PIN de seguridad de 4 a 6 caracteres para desbloquear este canal.'
                    );
                    break;
                case MODAL_PIN_CODE_LOCK_CHANNEL_TYPE_SEARCHER:
                    text.title = Translator.get(
                        'lockPIN_access_titleRecordings_label',
                        'Ver grabación bloqueada'
                    );
                    text.subtitle = Translator.get(
                        'lockPIN_search_subtitleRecordings_label',
                        'Grabación de canal bloqueado. Ingresa tu PIN de seguridad de 4 a 6 caracteres.'
                    );
                    break;
                default:
                    text.title = Translator.get('modal_pin_default_title', 'PIN de Seguridad');
                    text.subtitle = '';
            }
        }
        return text;
    };

    getButtonText = () => {
        const { isNewCode } = this.state;
        const { type } = this.props;
        let buttonText;
        if (isNewCode) {
            buttonText = Translator.get('modal_pin_change_button', 'Cambiar');
        } else {
            switch (type) {
                case MODAL_PIN_CODE_PURCHASE_TYPE:
                    buttonText = Translator.get('modal_pin_unlock_button', 'Desbloquear');
                    break;
                case MODAL_PIN_CODE_RATING_TYPE:
                    buttonText = Translator.get('modal_pin_unlock_button', 'Desbloquear');
                    break;
                case MODAL_PIN_CODE_CHANNEL_TYPE:
                    buttonText = Translator.get('modal_pin_unlock_button', 'Desbloquear');
                    break;
                case MODAL_PIN_CODE_LOCK_CHANNEL_TYPE_LIVE_TV:
                    buttonText = Translator.get('lockChannel_access_option_button_unlock', 'Siguiente');
                    break;
                case MODAL_PIN_CODE_CHANNEL_TYPE_SEARCHER:
                case MODAL_PIN_CODE_LOCK_CHANNEL_TYPE_SEARCHER:
                    buttonText = Translator.get('lockChannel_access_option_button_unlock', 'Siguiente');
                    break;
                default:
                    buttonText = Translator.get('bt_suscripcion_siguiente', 'Siguiente');
            }
        }
        return buttonText;
    };



    getButtonTextCancel = () => {
        const { isNewCode } = this.state;
        const { type } = this.props;
        let buttonText;
        if (isNewCode) {
            buttonText = Translator.get('modal_pin_cancel_button', 'Cancelar');
        } else {
            switch (type) {
                case MODAL_PIN_CODE_PURCHASE_TYPE:
                    buttonText = Translator.get('modal_pin_cancel_button', 'Cancelar')
                    break;
                case MODAL_PIN_CODE_RATING_TYPE:
                    buttonText = Translator.get('modal_pin_cancel_button', 'Cancelar');
                    break;
                case MODAL_PIN_CODE_CHANNEL_TYPE:
                    buttonText = Translator.get('modal_pin_cancel_button', 'Cancelar');
                    break;
                case MODAL_PIN_CODE_LOCK_CHANNEL_TYPE_LIVE_TV:
                    buttonText = Translator.get('lockChannel_access_option_button_cancel', 'Cancelar');
                    break;
                case MODAL_PIN_CODE_CHANNEL_TYPE_SEARCHER:
                case MODAL_PIN_CODE_LOCK_CHANNEL_TYPE_SEARCHER:
                    buttonText = Translator.get('lockChannel_access_option_button_cancel', 'Cancelar');
                    break;default:
                    buttonText = Translator.get('modal_pin_cancel_button', 'Cancelar');
            }
        }
        return buttonText;
    };

    removeListeners() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    addListeners() {
        document.addEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (e) => {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (currentKey === 'YELLOW') {
            this.handleYellowBack();
        } else if (isNumber(currentKey)) {
            onFocusMultipleElementsRC(this.getPinCodeActiveElemnt(), this.isFocusInput());
        }
    };

    onControlDeleteCallback(activeField, values, deleteCallback = () => {}) {
        this.deleting = true;
        if (values && values[activeField]) {
            deleteCallback();
            this.deleting = false;
        } else {
            const index = Utils.getOnlyDigitsInString(activeField);
            if (index !== 0) {
                //se agrega un pequeño delay para evitar issue de doble click
                const timeout = setTimeout(() => {
                    // this.focusOnPreviousInput(index);
                    if (document.activeElement.className.includes(KEYBOARD_CLASSNAME)) {
                        this.focusOnPreviousInput(index);
                    } else {
                        this.focusOnPreviousInput(index, RC);
                    }

                    this.onControlDeleteCallback(`code${index - 1}`, values, deleteCallback);
                    clearTimeout(timeout);
                }, 50);
            } else {
                this.deleting = false;
            }
        }
    }

    componentDidMount() {
        setInitialFocus('.aaf_form-group-input-element .aaf_focusable', false);
        document && document.addEventListener('sn:enter-up', this.enterUpHandler, true);
        const { action } = this.props;
        if (action === MP_RECORDAR_PIN) {
            this.handleRecovery();
        } else {
            this.setBlokedChannels();
        }
        this.addListeners();
        window.SpatialNavigation.focus('#' + this.codeSelected);
    }

    componentWillUnmount() {
        document && document.removeEventListener('sn:enter-up', this.enterUpHandler, true);
        this.removeListeners();
    }

    onBlur() {
        const temp = document;
        if (temp.activeElement.id === 'password') {
            this.setState({ errorFromBackend: '' });
        }
    }

    enterUpHandler = (e) => {
        const el = e.target;
        if (el.className.includes('aaf_focusable')) {
            this.codeSelected = e.target.id;
        }
    };

    onFocus() {
        onFocusMultipleElements(this.getPinCodeActiveElemnt());
    }

    render() {
        const { showCode, isEnabledButton, error } = this.state;
        const { action } = this.props;
        const { type="" } = this.props;
        const modalProps = {
            childrenClassName: `${MAIN_CLASSNAME}-wrapper`,
            cancelCallBack: this.handleYellowBack,
        };
        const text = this.getText();
        const buttonText = this.getButtonText();
        const buttonTextCancel = this.getButtonTextCancel();

        const {isFlowSearcherForPin = false} = store.getState().searcher;

        const validateClassForgetPin = isFlowSearcherForPin
        ? `${MAIN_CLASSNAME}-forgot-pin-searcher` : `${MAIN_CLASSNAME}-forgot-pin`
        const validateClassRequest = isFlowSearcherForPin
        ? `${MAIN_CLASSNAME}-request-pin-code-searcher` : `${MAIN_CLASSNAME}-request-pin-code`

        if (action === MP_RECORDAR_PIN) {
            return null;
        }
        return (
            <ModalWrapper {...modalProps}>
                <Grid className={cls(`${MAIN_CLASSNAME}`)}>
                    <HeaderCompound
                        disabled
                        align="right"
                        onClick={this.handleYellowBack}
                        onFocus={this.onFocus}
                        textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                        icon={`${Asset.get('top_head_option_back')}`}
                    />
                    <Row>
                        <Form>
                            <Column lg={6} className={cls(`${MAIN_CLASSNAME}-keyboard`)}>
                                <Keyboard
                                    className={'modal'}
                                    emptyAllField
                                    emptyCallback={this.focusOnFirstEmptyInput}
                                    emptyFunctionArr={this.emptyFunctionArr}
                                    onControlDeleteCallback={this.onControlDeleteCallback}
                                    onFocus={this.onFocus}
                                    withoutEmails
                                    sourceSearcher = { isFlowSearcherForPin }
                                />
                            </Column>
                            <Column lg={6} className={cls(validateClassRequest)}>
                                <Row className={cls(`${MAIN_CLASSNAME}-title`)}>{text.title}</Row>
                                <Row className={cls(`${MAIN_CLASSNAME}-subtitle`)}>
                                    {text.subtitle}
                                </Row>
                                <RequestPinCode
                                    error={error}
                                    handleChange={this.handleChange}
                                    showCode={showCode}
                                    togglePasswordVisibility={this.togglePasswordVisibility}
                                    onFocus={this.onFocus}
                                />
                                <Row>
                                    <Column lg={11} className={cls(`${MAIN_CLASSNAME}-button`)}>
                                        <Button
                                            id={'btnSubmit'}
                                            type="button"
                                            variant="primary"
                                            disabled={!isEnabledButton}
                                            className={cls(
                                                `focusable`,
                                                `${MAIN_CLASSNAME}-button-size`,
                                                'resizable'
                                            )}
                                            onClick={this.handleSubmit}
                                            block
                                            onFocus={this.onFocus}
                                        >
                                            {buttonText}
                                        </Button>
                                    </Column>
                                    <Column lg={11} className={cls(`${MAIN_CLASSNAME}-button`)}>
                                        <Button
                                            id="btnCancelar"
                                            type="button"
                                            className={cls(
                                                `focusable`,
                                                `${MAIN_CLASSNAME}-button-box-shadow`,
                                                `${MAIN_CLASSNAME}-button-size`
                                            )}
                                            onClick={this.handleCancel}
                                            block
                                            onFocus={this.onFocus}
                                        >
                                            {buttonTextCancel}
                                        </Button>
                                    </Column>
                                    {this.state.isEnableRecoveryPIN && (
                                        <Column
                                            lg={12}
                                            className={cls(`${validateClassForgetPin}`)}
                                        >
                                            <Tab
                                                onClick={this.handleRecovery}
                                                className={cls(
                                                    'focusable',
                                                    `${MAIN_CLASSNAME}-button-forgot-pin`
                                                )}
                                            >
                                                {Translator.get(
                                                    'modal_pin_forgot_pin',
                                                    '¿Olvidaste tu PIN? Recupéralo aquí'
                                                )}
                                            </Tab>
                                        </Column>
                                    )}
                                </Row>
                            </Column>
                        </Form>
                    </Row>
                </Grid>
            </ModalWrapper>
        );
    }
}

ModalPinCode.defaultProps = {
    handleClose: () => {},
    user: {},
    successCallBack: () => {},
    failedCallBack: () => {},
    pinIsCreated: false,
    type: '',
    activate: '',
    action: MP_CHECAR_STATUS,
    lastFocus: '',
    pinRatings: PIN_RATING_DEFAULT,
};

ModalPinCode.propTypes = {
    handleClose: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    successCallBack: PropTypes.func.isRequired,
    failedCallBack: PropTypes.func.isRequired,
    pinIsCreated: PropTypes.bool,
    type: PropTypes.string,
    activate: PropTypes.string,
    action: PropTypes.string,
    lastFocus: PropTypes.string,
    pinRatings: PropTypes.string,
};

const mapStateToProps = (state) => ({
    user: state.user,
});

const mapDispatchToProps = {
    showModal,
    setMetricsEvent,
};

export default connect(mapStateToProps, mapDispatchToProps)(withOnClose(ModalPinCode));



// WEBPACK FOOTER //
// ./src/components/Modal/ModalPinCode.jsx